import { createSelector } from "reselect";

//EXTRACT THE PART OF THE STATE
const getData = state => state.user.partnerPreference;

//VERIFY IF THE JWT IS SET
const getMyPartnerPreferenceRaw = createSelector(
  getData,
  preference => preference
);
export default getMyPartnerPreferenceRaw;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyPartnerPreferenceRaw.js